var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "security_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".security_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "security_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "security_svg__st1",
    d: "M17 9.76V5c0-2.76-2.24-5-5-5S7 2.24 7 5v4.76C5.17 11.23 4 13.47 4 16c0 4.42 3.58 8 8 8a7.998 7.998 0 0 0 5-14.24zM9 5c0-1.65 1.35-3 3-3s3 1.35 3 3v3.59c-.93-.38-1.94-.59-3-.59s-2.07.21-3 .59V5zm4 11.72V19h-2v-2.28c-.6-.35-1-.98-1-1.72 0-1.1.9-2 2-2s2 .9 2 2c0 .74-.4 1.38-1 1.72z"
  })));
};
export default SvgSecurity;